const pageCache = {
  state: {
    version: 0,
    breadcrumbParent: null,
    refreshRoutes: {}
  },

  mutations: {
    RESET_PAGE_CACHE(state) {
      state.version += 1
      state.breadcrumbParent = null
      state.refreshRoutes = {}
    },
    SET_BREADCRUMB_PARENT(state, parent) {
      state.breadcrumbParent = parent
    },
    CLEAR_BREADCRUMB_PARENT(state) {
      state.breadcrumbParent = null
    },
    MARK_PAGE_REFRESH(state, routeName) {
      state.refreshRoutes = Object.assign({}, state.refreshRoutes, {
        [routeName]: true
      })
    },
    CONSUME_PAGE_REFRESH(state, routeName) {
      const refreshRoutes = Object.assign({}, state.refreshRoutes)
      delete refreshRoutes[routeName]
      state.refreshRoutes = refreshRoutes
    }
  }
}

export default pageCache



// WEBPACK FOOTER //
// ./src/store/modules/pageCache.js